<template>
  <div class="bsgw_wrap">
    <div class="industry-container">
      <div class="layout-wrapper">
        <div class="H2div">
          <h2 class="industry-title" >业务板块</h2>
        </div>
        
        
        <div>
                  <div class="responsive-parallelogramContainer">
                          <!--  
                            v-scroll-animate="getAnimationName(index)"
                          > -->
                          <div 
                            v-for="(panel, index) in panels"
                            :key="index"
                            class="responsive-parallelogram"
                            @click="navigateToDetail(panel)"
                            @mouseover="indexNum = index"
                             @mouseleave="indexNum = null"
                            :class="(indexNum == index)?'activecssy0':''"
                            v-scroll-animate="'elementceshi'"
                          >
                                <div class="panel-overlay">
                                  <img :src="urlBase+panel.photo.slice(1)" style="position: absolute;z-index: -1;" />
                                    <h3 class="panel-title">{{ panel.explains }}</h3>
                                </div>
                          </div>
                        
                  </div>
        </div>

      </div>
    </div>
  </div>
</template>


<script>
import API from '@/api/bsInfo'

export default {
  data() {
    return {
      urlBase: process.env.VUE_APP_BASE_API,

      panels: [],
      indexNum:null,
    }
  },
  mounted() {
     this.getList();
   },
  methods:{
    getAnimationName(index) {
      return `slide-itembsgw${index}`
    },
    //获取业务板块首页内容
async getList() {
  try {
    let objParams={
      catId:'9e6274e05d4e40438c4a357704e3c56d'
    }
    const res = await API.getBusiness(objParams)
    this.panels = res.data.businessList
    console.log('获取成功', res.data.resultData)
  } catch (error) {
    console.error('获取失败', error)
  }
},
    
    navigateToDetail(currentPanel){
      const encodedTitle = encodeURIComponent(currentPanel.explains)
      this.$router.push({
        path: '/businessDetail',
        query: {                     
          title: encodedTitle
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.bsgw_wrap {
  min-height: 100vh;
   flex-direction: column;
  position: relative;
}

.industry-container {
  flex: 80%;
  // padding:1%vw 0;
  // padding-top:1vw;
  color: white;
  min-height: 50vw;
  display: flex;
  flex-direction: column;
  position: relative;
  @media screen and (max-width: 768px) {
    min-height: 100vh;
  }
  
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-image: url('../../assets/img3/yewubankuai/bg.png');
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
    z-index: 0;
    /* 移除亮度滤镜 */
  }
}

.layout-wrapper {
  height: 100%;
  display: grid;
  grid-template-rows: 1fr 3fr;
  padding:10vh;
  margin-top: -10vh;
  position: relative;
  z-index: 1;
  @media screen and (max-width: 768px) {
    // padding:30vh 1vw;
    padding-top:0;
    grid-template-rows: 1fr;
  }
}

.title-container {
  grid-row: 1;
  position: relative;
  align-self: end;
  padding-bottom: 1.5vh;
}

.industry-title {
  font-size: 1.5rem !important;
  margin: 0 0 0 5%;
  position: relative;
  line-height: 1.2;
  
  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -0.8vh;
    width: 30%;
    height: 2px;
  }
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}
.responsive-parallelogramContainer{
  display: flex;
  @media screen and (max-width: 768px) {
    flex-direction: column;
  }
}
 
.responsive-parallelogram {
 

  // opacity: 0;
  // animation: fadeIn 2s ease-in-out forwards;
  // width: 20%;
  flex: 1;
  height: 0; 
  padding-bottom: 30%; /* 保持宽高比 */
  position: relative;
  margin: 0 auto;
  display: inline-block;
  @media screen and (max-width: 768px) {
    width: 100%;
    padding-bottom: 0; /* 保持宽高比 */
    height: 350px; 
  }
}

.responsive-parallelogram::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform: skewX(-8deg);

  // border:2px solid #f00
}
.panel-title{
  font-size: 2em;
  padding-top:11vw;
  text-align: center;
  color: #f5f5f5;  
  @media screen and (max-width: 768px) {
    padding-top:37.5vw; font-size: 2rem;
  }
}
.panel-overlay{
  opacity:1;

  @media screen and (max-width: 768px) {
    height: 100%;
    img{
      width: 100%;
      height: 180px !important;
    }
  }
}
.activecssy0{
 .panel-overlay{
  img{
    // opacity:0.8;
    filter: brightness(90%); /* 降低亮度实现蒙层效果 */
  }
  h3{
    color: #4164d7;
    text-shadow: 0 1px 3px rgba(6, 50, 245, 0.6);
  }
 }
}
.H2div{
  //  background: red;
   h2{
    line-height: 8vw;
   }
}
 
</style>